export default __webpack_public_path__ + "static/media/ic_unflod.238ea3f2.svg";